<template>
  <!-- 注册送金 -->
  <div class="register-reward">
    <autoReward ref="autoRewardRef" v-if="isAutoReward" />
    <manualReward ref="manualRewardRef" v-else />
  </div>
</template>

<script>
import autoReward from "./autoReward.vue";
import manualReward from "./manualReward.vue";
export default {
  components: {
    autoReward,
    manualReward,
  },
  data() {
    return {};
  },
  computed: {
    // 自动领取奖励
    isAutoReward() {
      return Number(this.$store.getters.getPacketDomain?.activityInfo?.ActivityTypeRegister?.detail?.dispatchType) !== 2;
    },
    componentName() {
      return this.isAutoReward ? "autoRewardRef" : "manualRewardRef";
    },
  },
  created() {},
  mounted() {},
  methods: {
    show(obj) {
      this.$refs[this.componentName].show(obj);
    },
    close() {
      this.$refs[this.componentName].close();
    }
  },
};
</script>
